import { createFileRoute, useParams } from "@tanstack/react-router"
import CustomBoardPage from "@/components/coreBoard/CustomBoardPage"

function BoardRoute() {
  const { boardId } = useParams({ from: "/core/board/$boardId" })
  return <CustomBoardPage boardId={boardId} />
}

export const Route = createFileRoute("/core/board/$boardId")({ component: BoardRoute })
